import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'yesEmpty' })
export class YesEmptyPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Y' : '';
  }
}
